type User = {
  first_name: string;
  last_name: string;
  username: string;
};

const getUserInitial = (user: User): string => {
  if (user.first_name && user.last_name) {
    const name = `${user.first_name} ${user.last_name}`;
    const matches = name.match(/\b(\w)/g);
    if (!matches) {
      return '--';
    }
    return matches.join('').toUpperCase().substring(0, 2);
  }
  if (user.username) {
    return user.username.charAt(0).toUpperCase();
  }
  return '--';
};

export default getUserInitial;
